export default {
  supplierCollection: [],
  clientCollection: [],
  vehicleCollection: [],
  addressCollection: [],
  shippingCompanyCollection: [],
  ufCollection: [],
};
